import { deleteDocumentMutation, getDocumentQuery, listAllDocumentsQuery, updateDocumentMutation } from "../../graphql/queries";
import { DeleteDocumentMutation, DeleteDocumentMutationVariables, GetDocumentQuery, GetDocumentQueryVariables, ListAllDocumentsQuery, UpdateDocumentMutation, UpdateDocumentMutationInput, UpdateDocumentMutationVariables } from "../../graphql/types";
import { fetchGraphql, useGraphql } from "./graphqlClient";

export type BackendDocumentPreview = NonNullable<ListAllDocumentsQuery["self"]>["documentPreviews"][0];
export type BackendDocument = NonNullable<GetDocumentQuery["self"]>["document"];

export async function getAllDocuments(): Promise<ListAllDocumentsQuery | null> {
    const result = await fetchGraphql<ListAllDocumentsQuery, ListAllDocumentsQuery>("ListAllDocuments", listAllDocumentsQuery, { }, true);
    return result.data ?? null;
}

export function useAllDocuments(): { result: ListAllDocumentsQuery | null } {
    return useGraphql<ListAllDocumentsQuery, ListAllDocumentsQuery>("ListAllDocuments", listAllDocumentsQuery, {});
}

export async function getDocument(id: string): Promise<BackendDocument | null> {
    const result = await fetchGraphql<GetDocumentQuery, GetDocumentQueryVariables>("GetDocument", getDocumentQuery, { id }, true);
    return result.data?.self?.document?? null;
}

export async function updateDocument(input: UpdateDocumentMutationInput): Promise<boolean> {
    const result = await fetchGraphql<UpdateDocumentMutation, UpdateDocumentMutationVariables>("UpdateDocument", updateDocumentMutation, { input }, true);
    return result.data?.updateDocument?.ok ?? false;
}

export async function deleteDocument(id: string): Promise<boolean> {
    const result = await fetchGraphql<DeleteDocumentMutation, DeleteDocumentMutationVariables>("DeleteDocument", deleteDocumentMutation, { id }, true);
    return result.data?.deleteDocument ?? false;
}
